<template>
  <div>
    <el-container style="height:800px"   >
      <el-container>
        <el-main class="max">
          <div class="upload_btn">
            <el-button size="mini" @click="submitEvt" type="primary">完成</el-button>
          </div>
          <div  class="input_one"  v-if="id == undefined ? true :false">
            <span style="line-height: 26px;">  项目名称  :</span>
                <el-select v-model="project" filterable placeholder="项目名称" @change="projectChange" style="margin-left: 6px;"
                  clearable >
                  <el-option v-for="(item, index) in project_one" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
          </div>
          <div style="background-color: #fff;">
             <el-upload class="upload_box" action="#" list-type="picture-card" drag multiple :auto-upload="false"
                  :on-change="uploadEvt">
                  <i class="el-icon-plus"></i>
                </el-upload>
          </div>

          <div v-for="(item, index) in uploadImgList" :key="index" class="img_box">
            <img :src="item.url" alt="" />
             <div v-if="item.repeat" class="repeat_box">
                  <span>该照片重复</span>
              </div>
            <el-progress v-if="percentageShow && item.uid == regularNum" class="percentage_box"
              :percentage="percentage"></el-progress>
            <div class="complete_box" v-if="item.complete">
              <span style="text-align: center;">上传完成</span>
            </div>
            <div class="close_box" @click="closeImgEvt(item)">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import SparkMD5 from "spark-md5";
import { ExistsApi  , SignApi   , completeUploadApi  , startUploadApi   , SearchApi } from "@/api/work/index.js"

export default {
   props: {
    id: {
      type: Number,
    }
  },
  data() {
    return {
      input: "",
      nameList: [],
      nameId: "",
      categoryId: "",
      categoryInput: "",
      //上传列表
      dataList: [],
      uploadImgList: [],
      dialogVisible: false,
      timer: null,
      regular: null,
      regularNum: null,
      percentage: 30,
      percentageShow: false,
      project:null,
      project_one:null,
    };
  },
  created(){
    SearchApi().then(res=>{
          this.project_one = res.project
    })
  },
  methods: {
    projectChange(value){
      this.project = value
    },
    handleEnter() {
      if (this.nameList.length == 0) {
        this.addAuthor = true;
        this.AuthorNameInp = this.input;
        this.$nextTick(() => {
          this.$refs.nameInput.blur();
          this.$refs.authorInput.focus();
        });
      }
    },
    //上传
    uploadEvt(file, fileList) {
      let imgErr = (file, msg) => {
        let index = fileList.findIndex((fileItem) => {
          return fileItem.uid === file.uid;
        });
        fileList.splice(index, 1);
        this.$message({
          message: msg,
          type: "warning",
        });
        return false;
      };
      if (file.raw.type !== "image/jpg" && file.raw.type !== "image/jpeg") {
        return imgErr(file, "只支持jpg格式图片");
      }
      if (file.size / 1024 / 1024 > 50) {
        return imgErr(file, "图片大小不能超过 50MB!");
      }

      const fileReader = new FileReader();

      fileReader.readAsBinaryString(file.raw);

      fileReader.onload = (e) => {
        const md5 = SparkMD5.hashBinary(e.target.result);
        file.hash = md5;
        ExistsApi({
          md5,
        }).then((res) => {
          if (res.code == 1000) {
            file.percentage = true;
            this.dataList.push(file);
          }
          if (res.code == 1004) {
               this.$message({
              message: res.msg,
              type: "warning",
            });
            file.repeat = true;
          }
          this.percentageShow = true;
          this.uploadImgList.push(file);
        });
      };
    },
    //获取文件上传签名
    getReadyId(file) {
       let imgType = "";
      switch (file.raw.type) {
        case "image/png":
          imgType = ".png";
          break;
        case "image/jpeg":
          imgType = ".jpeg";
          break;
        case "image/jpg":
          imgType = ".jpg";
      }
      SignApi({
        filename: file.hash + imgType,
        md5:file.hash,
        project_id:this.project  ||  this.id,
      }).then((res) => {
        if (res.code == 1004) {
          this.$message({
            message: "上传失败",
            type: "warning",
          });
          return;
        }
        if (res.code == 1000) {
          this.startUpload(file, res);
        }
      });
    },
    //确定提交上传
    submitEvt() {
       if (this.dataList.length == 0) {
        this.$message({
          message: "请选择文件后上传",
          type: "warning",
        });
        return;
      }
      this.regular = setInterval(() => {
        if (this.dataList.length == 0) {
          // uploadTs.value = true
          return;
        }
        this.getReadyId(this.dataList.pop());
      }, 1000);
      this.percentageShow = true;
    },
    //code1000
    startUpload(file, data) {
      this.percentageShow = true;
      let url = data.host;
      let formData = new FormData();
      let imgType = "";
      switch (file.raw.type) {
        case "image/png":
          imgType = ".png";
          break;
        case "image/jpeg":
          imgType = ".jpeg";
          break;
        case "image/jpg":
          imgType = ".jpg";
      }
      formData.append("key", file.hash + imgType);
      formData.append("policy", data.policy);
      formData.append("OSSAccessKeyId", data.accessid);
      formData.append("success_action_status", "200");
      formData.append("signature", data.signature);
      formData.append("file", file.raw);

      formData.append("filename", file.hash + imgType);
      this.regularNum = file.uid;

      startUploadApi(url, formData).then((res) => {
        setInterval(() => {
          if (this.percentage >= 100) {
            return;
          }
          this.percentage += 2;
        }, 20);
        completeUploadApi({
          image_id :data.image_id,
        }).then((val) => {
          this.uploadImgList = this.uploadImgList.map((v) => {
            if (v.uid == file.uid) {
              v.complete = true;
            }
            return v;
          });
          this.percentageShow = false;
          this.percentage = 30;
        });
      });
    },
    //删除上传列表
    closeImgEvt(data) {
      if (data.percentage) {
        this.dataList.map((v, index) => {
          if (v.uid == data.uid) {
            this.dataList.splice(index, 1);
          }
        });
      }
      this.uploadImgList.map((res, index) => {
        if (data.uid == res.uid) {
          this.uploadImgList.splice(index, 1);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.name_box {
  width: 100%;
  background-color: rgba(103, 195, 249, 0.2);
  border-radius: 7px;
  height: 35px;
  padding: 3px;
  padding-left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.name_box span {
  height: 27px;
  line-height: 27px;
  padding-left: 10px;
  color: #fff;
  background-color: rgb(43, 147, 233);
  font-size: 12px;
}

.nameSearch {
  position: absolute;
  margin-left: 15px;
  width: 230px;
}

/deep/.nameSearch input {
  height: 29px;
  border: none;
  background: none;
  font-size: 12px;
}

/deep/.el-tag .el-icon-close {
  color: #fff;
}

.name_box .el-icon-plus {
  background-color: #848282;
  font-size: 15px;
  border-radius: 50%;
  margin-right: 15px;
  color: #fff;
}

.result_box {
  margin-top: 8px;
  width: 100%;
  max-height: 400px;
  min-height: 400px;
  overflow-x: hidden;
  border-radius: 5px;
  padding: 3px;
  box-shadow: 0px 0px 4px 0px #d6d5d5;
}

.Selected {
  padding-left: 20px;
  height: 20px;
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  cursor: pointer;
}

.Selected:hover {
  background-color: rgba(103, 195, 249, 0.2);
  border-radius: 3px;
}

.Selected div {
  position: relative;
}

.Selected b {
  display: block;
  width: 12px;
  height: 12px;
  border: 1px solid #369cdc;
  border-radius: 50%;
  margin-top: 2px;
}

.Selected i {
  display: block;
  width: 8px;
  height: 8px;
  background-color: #369cdc;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 2px;
}

.Selected span {
  padding-left: 20px;
}

.addAuthor {
  margin-top: 10px;
  height: 300px;
  border-radius: 5px;
  padding: 3px;
  position: relative;
  font-size: 12px;
  box-shadow: 0px 0px 4px 0px #d6d5d5;
}

.addAuthor p {
  font-size: 15px;
}

.author_box {
  display: flex;
  justify-content: space-around;
}

.screen_box {
  position: absolute;
  top: 100px;
  right: 10px;
  width: 120px;
  height: 60px;
  padding: 3px;
  box-shadow: 0px 0px 4px 0px #d6d5d5;
}

.category {
  position: relative;
  display: flex;
  margin: 5px;
  cursor: pointer;
}

.category:hover {
  background-color: rgba(103, 195, 249, 0.2);
  border-radius: 3px;
}

.category span {
  padding-left: 15px;
}

.screen_box b {
  display: block;
  width: 12px;
  height: 12px;
  border: 1px solid #369cdc;
  border-radius: 50%;
  margin-top: 2px;
}

.screen_box i {
  display: block;
  width: 8px;
  height: 8px;
  background-color: #369cdc;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 2px;
}

.upload_box {
  float: left;
  width: 245px;
}

.img_box {
  width: 240px;
  height: 160px;
  float: left;
  position: relative;
  margin: 0 10px;
}
.img_box :nth-child(1){
  margin-left: 40px;
  padding-left: 10px;
}
.img_box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #d5d5d5;
}

.repeat_box {
  position: absolute;
  width: 100%;
  // background: url("../img/cha.png") no-repeat 8px center / 12px 12px;
  background-color: rgb(108, 108, 108, 0.5);
  bottom: 1px;
  color: #f00;
  font-weight: 600;
}

.complete_box {
  position: absolute;
  background-color: rgb(108, 108, 108, 0.8);
  width: 90%;
  bottom: 1px;
  color: #fff;
  left: 50px
}

.complete_box span {
  padding-left: 20px;
}

.repeat_box span {
  padding-left: 20px;
}

.close_box {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 19px;
  color: #000;
  cursor: pointer;
}

.percentage_box {
  position: absolute;
  width: 100%;
  bottom: 1px;
}

/deep/.el-progress__text {
  color: #fff !important;
}

.btn_box {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.upload_btn {
  position: absolute;
  top: 25px;
  right: 50px;

}

/deep/.el-upload-dragger {
  width: 240px;
  height: 160px;
}

/deep/.el-upload-list--picture-card {
  display: none;
}

/deep/.el-upload--picture-card {
  border: none;
}

.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

.input_one{
  display: flex;
  margin-bottom: 20px;
  margin-left: 10px;
 /deep/.el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
    width: 500px;
  }

  /deep/.el-input__icon {
    line-height: 0px;
  }
}
/deep/.el-dialog{
  background-color: #d5d5d5 !important;
}

/deep/.max{
  overflow: hidden !important;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Upload.vue